// extracted by mini-css-extract-plugin
export var modal = "_fw-0";